// extracted by mini-css-extract-plugin
export default {"box":"Box_box__s7yHd","gradient":"Box_gradient__HTXFE","header":"Box_header__RcfHj"};